import { useState, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Link, useLocation } from "react-router-dom";

export const CookieBanner = () => {
  const [show, setShow] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const t = setTimeout(() => {
      if (!localStorage.getItem("cookie_consent")) setShow(true);
    }, 800);
    return () => clearTimeout(t);
  }, []);

  const decide = (value) => {
    localStorage.setItem("cookie_consent", value);
    setShow(false);
  };

  if (location.pathname.startsWith("/admin")) return null;

  return (
    <AnimatePresence>
      {show && (
        <motion.div
          initial={{ y: 120, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: 120, opacity: 0 }}
          transition={{ duration: 0.5, ease: [0.16, 1, 0.3, 1] }}
          className="fixed bottom-0 left-0 right-0 z-[70] bg-[#141A14] border-t border-white/15"
          data-testid="cookie-banner"
        >
          <div className="max-w-[1600px] mx-auto px-5 md:px-12 py-6 flex flex-col md:flex-row md:items-center gap-5 md:gap-10">
            <p className="text-sm text-[#E8E2D2]/70 leading-relaxed flex-1">
              Utilizziamo cookie tecnici e, previo consenso, cookie di
              statistica per migliorare la tua esperienza. Consulta la{" "}
              <Link to="/cookie-policy" className="text-[#D47738] underline underline-offset-2">
                Cookie Policy
              </Link>{" "}
              per maggiori dettagli.
            </p>
            <div className="flex gap-3 shrink-0">
              <button
                onClick={() => decide("rejected")}
                className="border border-white/20 text-[#E8E2D2] px-6 py-3 font-mono-accent text-[11px] uppercase tracking-[0.2em] hover:border-white/50 transition-colors"
                data-testid="cookie-reject-btn"
              >
                Rifiuta
              </button>
              <button
                onClick={() => decide("accepted")}
                className="bg-[#D47738] text-[#0D110D] px-6 py-3 font-mono-accent text-[11px] uppercase tracking-[0.2em] hover:bg-[#E8E2D2] transition-colors"
                data-testid="cookie-accept-btn"
              >
                Accetta
              </button>
            </div>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};
